import axios from 'axios';
import c from '../helpers/constants';
import { getApiKey, objectToQueryString } from '../helpers/functions';

export function getStock(customerId: string, sku: string, cutLength?: number, width?: number, quantity?: string) {
  const obj = {
    customerid: encodeURIComponent(customerId),
    searchsku: encodeURIComponent(sku),
    cutlength: cutLength,
    searchwidth: width,
    searchquantity:quantity,
  };
  const queryString = objectToQueryString(obj);
  return (
    axios({
      url: `${c.API_ENDPOINTS.CHECK_STOCK}?${queryString}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'x-api-key': getApiKey()
      },
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}
